import React from "react";
import "./css/AccessToInformation.css";
import { FaRegFileAlt, FaRegNewspaper, FaBookOpen } from "react-icons/fa";

const AccessToInformation = () => {
  return (
    <div className="access-info-page">
      {/* === Header === */}
       {/* === Header Section === */}
       <section className="about-header testing-header">
          <div className="overlay">
            <h1 className="page-title">Access to Information</h1>
            <p className="subtitle">
                Promoting openness, accountability, and the public’s right to
                information at the Malawi Bureau of Standards (MBS).
            </p>
          </div>
        </section>

      {/* === What You Can Access Section === */}
      <section className="what-access">
        <h2>What Information You Can Access from MBS</h2>
        <div className="info-cards">
          <div className="info-card">
            <FaRegFileAlt className="card-icon" />
            <h3>Standards & Technical Documents</h3>
            <p>
              Access national and international standards, technical guidelines,
              and the official Malawi Standards Catalogue.
            </p>
          </div>

          <div className="info-card">
            <FaRegNewspaper className="card-icon" />
            <h3>Reports & Publications</h3>
            <p>
              View MBS annual reports, strategic plans, press releases, and
              public announcements that promote transparency.
            </p>
          </div>

          <div className="info-card">
            <FaBookOpen className="card-icon" />
            <h3>Testing & Certification Records</h3>
            <p>
              Find publicly available information on testing outcomes,
              certification decisions, and product compliance notices.
            </p>
          </div>
        </div>
      </section>

      {/* === Legal Framework Section === */}
      <section className="legal-framework">
        <h2>Legal Basis & How It Works</h2>
        <p>
          The <strong>Access to Information Act (2017)</strong> grants citizens
          the right to obtain information held by public institutions, including
          the Malawi Bureau of Standards, subject to lawful exemptions.
        </p>
        <p>
          MBS practices proactive disclosure — making key reports, standards,
          and updates publicly available through its website and media
          channels.
        </p>
        <p>
          If a request for information is denied, citizens may request an
          internal review or appeal to oversight authorities.
        </p>
      </section>

      {/* === Contact Section === */}
      <section className="pio-contact">
        <h2>Contact the Public Information Officer (PIO)</h2>
        <p>For formal information requests, please contact:</p>
        <ul>
          <li>
            <strong>Name:</strong> Public Information Officer, MBS
          </li>
          <li>
            <strong>Email:</strong>{" "}
            <a href="mailto:info@mbs.mw">info@mbs.mw</a>
          </li>
          <li>
            <strong>Mailing Address:</strong> P.O. Box 946, Blantyre, Malawi
          </li>
          <li>
            <strong>Phone:</strong> +265 (0)1 870 273
          </li>
        </ul>
      </section>
    </div>
  );
};

export default AccessToInformation;
